define.alias("shared/utils/string-formatters/camel-to-snake", "media/utils/string-formatters/camel-to-snake");